<template>
    <div class="generationWebSiteLink">
        <el-breadcrumb class="bread-nav" separator="/">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>一点彩票</el-breadcrumb-item>
            <el-breadcrumb-item>链接生成器</el-breadcrumb-item>
        </el-breadcrumb>
        <el-form :inline="true" ref="form" class="generationLink" :model="form" :rules="validateRules" align="left">
            <el-form-item label="链接" prop="redirectUrl">
                <el-input v-model="form.redirectUrl" placeholder="第三方链接地址"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="generationLink('form')">生成链接</el-button>
                <el-button @click="cancal">取消</el-button>
            </el-form-item>
        </el-form>
        <div class="output-box" v-if="form.linkUrl" v-text="form.linkUrl"></div>
    </div>
</template>
<script>
import CONFIG from "@/config/index.js";
import TOOL from '@/tool/index.js';
import router from "@/router/index.js";
export default {
    name: "generationWebSiteLink",
    data() {
        var linkUrl = (rule, value, callback) => {
            console.log(value);
            var regImage = new RegExp('^http://'),
                regVideo = new RegExp('^https://');
            if (!value) {
                callback(new Error('请填写链接地址'));
            } else if (! regImage.test(value) && !regVideo.test(value)) {
                callback(new Error('链接格式不正确，链接前需添加 http:// 或者 https://'));
            } else {
                callback();
            }
        }
        return {
            validateRules: {
                redirectUrl: [
                    { required: true, validator: linkUrl, trigger: 'change' }
                ]
            },
            form: {
              linkUrl: null,
              redirectUrl: null
            }
        };
    },
    methods: {
        generationLink(formName){
          let flag = true,
              self = this,
              host = CONFIG.HOST;
          this.$refs[formName].validate((valid) => {
              if (!valid) {
                  flag = false;
                  return false;
              }
          });
          if (!flag) {
              return;
          }
          self.form.linkUrl = host + "/lottery/view/redirect" + "?redirectUrl=" + encodeURIComponent(self.form.redirectUrl);
        },
        cancal(){
          let self = this;
          for (var key in self.form) {
            self.form[key] = null;
          }
        }
    }
};
</script>
<style lang="less">
    .generationWebSiteLink{
        width: 98%;
        margin: 0 auto;
        .bread-nav{
            margin: 20px 0;
        }
        .generationLink{
            text-align: left;
            .select-box{
                width: 220px;
            }
            .el-input{
              min-width: 500px;
            }
        }
        .output-box{
          border: 1px solid #bfcbd9;
          border-radius: 4px;
          width: 725px;
          min-height: 30px;

          margin-top: 30px;

          text-align: center;

          line-height: 30px;
          text-decoration: underline;

          word-wrap: break-word;
        }
    }
</style>



// WEBPACK FOOTER //
// LinkGenerate.vue?8022c8d6